module.exports = __webpack_public_path__ + "img/sld_scb_32_t1_b1_green.22bec339.svg";